/* istanbul ignore file */
import { Logger as clientLogger, LOG_LEVEL } from 'beaver-logger';
import serverData from './server-data';

export default clientLogger({
    url: '/cponboarding/log',
    logLevel: serverData.isProd ? LOG_LEVEL.WARN : LOG_LEVEL.DEBUG,
    prefix: 'cponboardingnodeweb'
});
